import { memo, useMemo } from "react";
import { Marker, Popup, Tooltip } from "react-leaflet";
import L from "leaflet";

const formatNum = (v, digits = 6) => {
    const n = typeof v === "number" ? v : Number(v);
    return Number.isFinite(n) ? n.toFixed(digits) : String(v ?? "");
};

const InfoRow = ({ label, value }) =>
    value ? (
        <div>
            <span style={{ color: "#666", fontSize: "16" }}>{label}: </span>
            <span style={{ fontSize: "16" }}>{value}</span>
        </div>
    ) : null;

const AtonMarker = ({ a, iconOptions }) => {
    const icon = useMemo(() => {
        const base = {
            iconUrl: a.symbol,
            iconSize: [36, 36],
            iconAnchor: [18, 32],
            tooltipAnchor: [0, -32],
            className: "",
        };
        return L.icon({ ...base, ...(iconOptions || {}) });
    }, [a.symbol, iconOptions]);

    return (
        <Marker position={[a.lat, a.lng]} icon={icon}>
            {/* ⬇️ 마커 위에 항상 보이는 라벨 */}
            <Tooltip
                direction="top"
                offset={[0, 0]}        // 아이콘 높이에 맞춰 약간 위로
                opacity={1}
                permanent
                className="aton-label"
            >
                {a.name_ko || a.name_en || "표지"}
            </Tooltip>

            <Popup>
                <div style={{ minWidth: 160 }}>
                    <div style={{ fontWeight: 600, marginBottom: 6, fontSize: 16 }}>
                        {a.name_ko || a.name_en || "표지"}
                    </div>

                    <InfoRow label="표지번호" value={a.aton_number} />
                    <InfoRow label="위도" value={`${a.latitude} (${formatNum(a.lat)})`} />
                    <InfoRow label="경도" value={`${a.longitude} (${formatNum(a.lng)})`} />
                    <InfoRow label="도색" value={a.color} />
                    <InfoRow label="형상" value={a.shape} />
                    <InfoRow label="사슬길이" value={a.chain_length} />
                    <InfoRow label="고삐사슬길이" value={a.mooring_chain_length} />
                    <InfoRow label="전환" value={a.transition} />
                    <InfoRow label="접환" value={a.connection} />
                    <InfoRow label="침추" value={a.sinker} />
                    <InfoRow label="전체 사슬길이" value={a.total_chain_length ? `${a.total_chain_length}m` : undefined} />
                    <InfoRow label="수심" value={a.sounding ? `${a.sounding}m` : undefined} />
                    <InfoRow label="조위" value={a.level_m ? `${a.level_m}m` : undefined} />
                    <InfoRow label="최근 부표 작업일" value={a.last_buoy_work_date} />
                </div>
            </Popup>
        </Marker>
    );
}

export default memo(AtonMarker);
